// Mirror of backend/constants/meetingOptions.js — keep in sync.
export const WINNING_CHANCE = ['High Chance', 'So-So', 'Low Chance'];
// Short display labels (mockup wording) for the stored WINNING_CHANCE values above.
// Display only — the stored/submitted value is always the full string.
export const CHANCE_LABEL = { 'High Chance': 'High', 'So-So': 'So-so', 'Low Chance': 'Low' };
export const DEAL_STATUSES = [
  'Quotation', 'Negotiating', 'Pending Decision',
  'Invoiced', 'Pending Payment', 'Deposit Collected (Won)', 'Lost Deal'
];
// Emoji shown next to certain statuses (display only — NOT part of the stored value).
export const STATUS_EMOJI = {
  'Deposit Collected (Won)': '🎉',
  'Lost Deal': '❌'
};
// Done-Deals-by-venue codes — the company's six event spaces, in the company's own
// order (WU/MR/WN are the three W Nexus sites). Code MB (Maybank) was retired on
// 2026-09-10: it was the Kuala Lumpur site under a second name.
export const VENUES = [
  { code: 'WF', label: 'W Factory' },
  { code: 'WU', label: 'W Nexus (1 Utama)' },
  { code: 'WT', label: 'W Timber' },
  { code: 'WS', label: 'W in the Sky' },
  { code: 'MR', label: 'W Nexus (Kelana Jaya)' },
  { code: 'WN', label: 'W Nexus (Kuala Lumpur)' }
];
export const WNEXUS_CODES = ['WU', 'MR', 'WN'];
